import { Injectable } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
import { isNullOrUndefined } from 'util';

import { Constants } from '../constants';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class IsauthorizedService {

  constructor(
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private authorizationService: AuthorizationService
  ) { }

  public checkControlAuthorization(controlKey: string) {
    let isAuthorized = false;
    const claims = this.authenticationService.GetClaims();
    // tslint:disable-next-line: no-string-literal
    if (claims !== null && claims !== undefined) {
      const extensionPermissions = this.localStorageService.GetClaimsTransformed(claims.extension_permissions).map((item: string) => item.trim());
      let authorizedControlList = JSON.parse(this.localStorageService.getItem(Constants.AUTHORIZED_CONTROLS));
      if (isNullOrUndefined(authorizedControlList)) {
        this.authorizationService.getAuthorizedControlList().subscribe(data => {
          this.localStorageService.setItem(Constants.AUTHORIZED_CONTROLS, JSON.stringify(data));
          authorizedControlList = JSON.parse(this.localStorageService.getItem(Constants.AUTHORIZED_CONTROLS));
          isAuthorized = this.isControlAuthorized(authorizedControlList, controlKey, extensionPermissions);

        });
      } else {
        isAuthorized = this.isControlAuthorized(authorizedControlList, controlKey, extensionPermissions);
      }
    }

    return isAuthorized;


  }
  private isControlAuthorized(authorizedControlList: any, controlKey: string, extensionPermissions: any): boolean {
    let value = false;
    if (!isNullOrUndefined(authorizedControlList)) {

      authorizedControlList.forEach(element => {
        if (element.key === controlKey) {

          const groups = element.groups.split(',');
          groups.forEach(claimGroup => {

            extensionPermissions.forEach(permission => {
              if (permission === claimGroup) {
                value = true;
              }
            });
          });
        }
      });
    }

    return value;
  }


}
